import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../libs/AuthContext";

export default function LicenseManagerRoute() {
  const { isLicenseManager } = useAuth();
  const location = useLocation();
  if (!isLicenseManager) {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }
  return <Outlet />;
}
